import Solution from "./solution";
// import compare from "../../Utils/compare";

const testCases = [
  {
    str: "ab",
    key: 14,
  },
  {
    str: "ymdadmt",
    key: 15,
  },
  {
    str: "abca",
    key: 11,
  },
  {
    str: "abc",
    key: 9,
  },
  {
    str: "ABCDCBA",
    key: 13,
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { str, key } = test;
      let outcome1 = output()(str, key);
      let outcome2 = Solution(str, key);
      const result = outcome1 === outcome2;
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
